/* cg-reviews.js — het reviewsysteem van Brand OS, zonder afhankelijkheden.
   Sectie B: reviews laden uit de JSON-pagina's bij "Meer reviews laden",
   filteren op sterren of op foto's, sorteren (recent, met foto's, hoogste,
   laagste, meest behulpzaam), lightbox voor klantfoto's, aantallen netjes.
   Sectie A: stipjes bij de swipe op mobiel, en "Meer reviews" die soepel
   naar sectie B scrolt. De rating bovenin de PDP: als de snippet niet in
   de hoofdsectie kon, zet dit script hem onder de titel. Zonder data doet
   het niets en breekt het niets. */
(function () {
  'use strict';
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var getal = function (n, locale) { try { return new Intl.NumberFormat(locale || 'nl-NL').format(n); } catch (e) { return String(n); } };
  var datum = function (iso, locale) { if (!iso) return ''; try { var d = new Date(iso + 'T12:00:00'); return new Intl.DateTimeFormat(locale || 'nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }).format(d); } catch (e) { return iso; } };
  var sterren = function (r, size) {
    var vol = Math.floor(r), rest = r - vol, half = 0;
    if (rest >= 0.75) vol++; else if (rest >= 0.25) half = 1;
    var pad = 'M12 2.5l2.9 6.1 6.7.8-4.9 4.6 1.3 6.6L12 17.3l-6 3.3 1.3-6.6L2.4 9.4l6.7-.8z';
    var h = '<span class="cg-stars" role="img" aria-label="' + esc(Math.round(r * 10) / 10) + ' van 5 sterren" style="--cg-star-size:' + (size || 18) + 'px">';
    for (var i = 1; i <= 5; i++) {
      if (i <= vol) h += '<svg class="cg-star cg-star--vol" viewBox="0 0 24 24" aria-hidden="true"><path d="' + pad + '"/></svg>';
      else if (half && i === vol + 1) h += '<svg class="cg-star cg-star--half" viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="cgjs' + i + '"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><path d="' + pad + '" fill="url(#cgjs' + i + ')" stroke="currentColor" stroke-width="1.2"/></svg>';
      else h += '<svg class="cg-star cg-star--leeg" viewBox="0 0 24 24" aria-hidden="true"><path d="' + pad + '"/></svg>';
    }
    return h + '</span>';
  };
  var VERIFIED = '<span class="cg-review__verified"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6.5 11.2 3.3 8l1.1-1.1 2.1 2.1 5.1-5.1L12.7 5z"/></svg>Geverifieerde koper</span>';

  /* Aantallen netjes (1244 → 1.244) overal waar data-cg-count staat */
  var locale = (document.documentElement.lang || 'nl').indexOf('en') === 0 ? 'en-US' : 'nl-NL';
  document.querySelectorAll('[data-cg-count]').forEach(function (el) {
    var n = parseInt(el.getAttribute('data-cg-count'), 10);
    if (isFinite(n)) el.textContent = el.textContent.replace(String(n), getal(n, locale));
  });

  /* Soepel scrollen naar de reviews */
  var scrollNaar = function (e) {
    var doel = document.getElementById('cg-reviews');
    if (!doel) return;
    e.preventDefault();
    doel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  document.querySelectorAll('[data-cg-scroll], [data-cg-rating]').forEach(function (a) { a.addEventListener('click', scrollNaar); });

  /* De rating bovenin: onder de titel als de snippet er niet staat */
  (function () {
    if (document.querySelector('[data-cg-rating]')) return;
    var sectie = document.querySelector('[data-cg-reviews]');
    if (!sectie) return;
    var count = parseInt(sectie.getAttribute('data-count'), 10) || 0;
    if (!count) return;
    var cijfer = sectie.querySelector('.cg-reviews__cijfer');
    var titel = document.querySelector('.product__title h1, .product__title, .product-single__title, .product__info-container h1, h1.product-title, .product-info h1, main h1, h1');
    if (!titel || !cijfer) return;
    var avg = parseFloat(String(cijfer.textContent).replace(',', '.')) || 0;
    var a = document.createElement('a');
    a.className = 'cg-rating'; a.href = '#cg-reviews'; a.setAttribute('data-cg-rating', '');
    a.setAttribute('aria-label', 'Beoordeling ' + avg + ' van 5 op basis van ' + count + ' reviews; ga naar de reviews');
    a.innerHTML = sterren(avg, 15) + '<span class="cg-rating__cijfer">' + esc(String(avg).replace('.', ',')) + '</span><span class="cg-rating__scheiding" aria-hidden="true">·</span><span class="cg-rating__aantal">' + esc(getal(count, locale)) + ' reviews</span>';
    a.addEventListener('click', scrollNaar);
    titel.insertAdjacentElement('afterend', a);
  })();

  /* Lightbox */
  var box = document.querySelector('[data-cg-lightbox-vak]');
  var openBox = function (url, alt) {
    if (!box) return;
    var img = box.querySelector('[data-cg-lightbox-img]');
    img.src = url; img.alt = alt || '';
    box.hidden = false; box._vorig = document.activeElement; box.querySelector('[data-cg-lightbox-sluit]').focus();
    document.body.style.overflow = 'hidden';
  };
  var sluitBox = function () { if (!box || box.hidden) return; box.hidden = true; document.body.style.overflow = ''; if (box._vorig && box._vorig.focus) box._vorig.focus(); };
  if (box) {
    box.addEventListener('click', function (e) { if (e.target === box || e.target.hasAttribute('data-cg-lightbox-sluit')) sluitBox(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluitBox(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cg-lightbox]');
    if (b) { e.preventDefault(); var im = b.querySelector('img'); openBox(b.getAttribute('data-cg-lightbox'), im ? im.alt : ''); }
  });

  /* Sectie A: de slider die zelf loopt. Geen knoppen voor de bezoeker. Om
     de zoveel seconden één kaart verder; na de laatste zichtbare positie
     glijdt de rij terug naar het begin (één langere beweging, geen sprong).
     Stil bij hover, bij toetsenbordfocus, als het tabblad niet zichtbaar is,
     en helemaal niet bij prefers-reduced-motion. Bij een resize wordt de
     positie opnieuw berekend, zodat er nooit een halve kaart staat. */
  document.querySelectorAll('[data-cg-testimonials]').forEach(function (sec) {
    var venster = sec.querySelector('[data-cg-venster]'), rij = sec.querySelector('[data-cg-rij]');
    if (!venster || !rij) return;
    var kaarten = rij.querySelectorAll('[data-cg-kaart]');
    var interval = Math.max(3, Math.min(30, parseInt(sec.getAttribute('data-interval'), 10) || 7)) * 1000;
    var autoplay = sec.getAttribute('data-autoplay') !== 'false';
    var rustig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null, pauze = false;
    var stap = function () { var k = kaarten[0]; if (!k) return 0; var gap = parseFloat(getComputedStyle(rij).columnGap || getComputedStyle(rij).gap) || 0; return k.getBoundingClientRect().width + gap; };
    var zichtbaar = function () { var s = stap(); return s ? Math.max(1, Math.round((venster.clientWidth + (parseFloat(getComputedStyle(rij).columnGap || getComputedStyle(rij).gap) || 0)) / s)) : 1; };
    var laatste = function () { return Math.max(0, kaarten.length - zichtbaar()); };
    var zet = function (n, terug) {
      i = Math.max(0, Math.min(laatste(), n));
      rij.classList.toggle('is-terug', !!terug);
      rij.style.transform = 'translate3d(' + (-i * stap()) + 'px,0,0)';
    };
    var verder = function () {
      if (pauze || document.hidden) return;
      if (i >= laatste()) zet(0, true); else zet(i + 1, false);
    };
    var start = function () { stop(); if (autoplay && !rustig && kaarten.length > zichtbaar()) timer = setInterval(verder, interval); };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    sec.addEventListener('mouseenter', function () { pauze = true; });
    sec.addEventListener('mouseleave', function () { pauze = false; });
    sec.addEventListener('focusin', function () { pauze = true; });
    sec.addEventListener('focusout', function () { pauze = false; });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    var her = null;
    window.addEventListener('resize', function () { clearTimeout(her); her = setTimeout(function () { rij.style.transition = 'none'; zet(i, false); void rij.offsetWidth; rij.style.transition = ''; start(); }, 150); });
    zet(0, false);
    start();
  });

  /* Sectie B: laden, filteren, sorteren */
  document.querySelectorAll('[data-cg-reviews]').forEach(function (sec) {
    var lijst = sec.querySelector('[data-cg-lijst]'), meer = sec.querySelector('[data-cg-meer]'), leeg = sec.querySelector('[data-cg-leeg]');
    var sortEl = sec.querySelector('[data-cg-sort]');
    if (!lijst) return;
    var batch = parseInt(sec.getAttribute('data-batch'), 10) || 10;
    var count = parseInt(sec.getAttribute('data-count'), 10) || 0;
    var pages = parseInt(sec.getAttribute('data-pages'), 10) || 0;
    var indexUrl = sec.getAttribute('data-index-url') || '';
    var showVerified = sec.getAttribute('data-show-verified') !== 'false';
    var loc = (sec.getAttribute('data-locale') || 'nl').indexOf('en') === 0 ? 'en-US' : 'nl-NL';
    var st = { alle: [], geladen: 0, laden: false, filter: 'alle', sort: 'nieuwste', getoond: batch, klaar: pages === 0 };
    var sleutel = function (x) { return (x.d || '') + '|' + (x.n || '') + '|' + String(x.b || '').slice(0, 40); };

    /* De eerste reeks staat al in de HTML (server-side): lees hem terug als
       data zodat filteren en sorteren ook daarover werken. */
    lijst.querySelectorAll('[data-cg-review]').forEach(function (el) {
      var x = {
        n: (el.querySelector('.cg-review__auteur') || {}).textContent || '', i: (el.querySelector('.cg-review__avatar') || {}).textContent || '',
        r: parseInt(el.getAttribute('data-rating'), 10) || 5, t: (el.querySelector('.cg-review__titel') || {}).textContent || '',
        b: (el.querySelector('.cg-review__tekst') || {}).textContent || '', d: el.getAttribute('data-date') || '',
        v: !!el.querySelector('.cg-review__verified'), m: Array.prototype.map.call(el.querySelectorAll('.cg-review__foto'), function (b) { var im = b.querySelector('img'); return { url: b.getAttribute('data-cg-lightbox'), alt: im ? im.alt : '' }; }),
      };
      x._k = sleutel(x); st.alle.push(x);
    });

    var paginaUrl = function (n) { return indexUrl.replace(/\.json(\?.*)?$/, '-' + n + '.json'); };
    var laadPagina = function () {
      if (st.laden || st.klaar) return Promise.resolve(false);
      st.laden = true; if (meer) { meer.disabled = true; meer.setAttribute('aria-busy', 'true'); }
      var n = st.geladen + 1;
      return fetch(paginaUrl(n), { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('pagina ' + n); return r.json(); }).then(function (rows) {
        var bestaand = {};
        st.alle.forEach(function (x) { bestaand[x._k] = true; });
        (rows || []).forEach(function (x) { var k = sleutel(x); if (!bestaand[k]) { x._k = k; st.alle.push(x); bestaand[k] = true; } });
        st.geladen = n; if (n >= pages || !rows || !rows.length) st.klaar = true;
        return true;
      }).catch(function () { st.klaar = true; return false; }).then(function (ok) { st.laden = false; if (meer) { meer.disabled = false; meer.removeAttribute('aria-busy'); } return ok; });
    };
    var laadAlles = function () { return laadPagina().then(function (ok) { return ok && !st.klaar ? laadAlles() : null; }); };

    var heeftFoto = function (x) { return (x.m || []).some(function (m) { return m && m.url; }); };
    var kaart = function (x) {
      var fotos = (x.m || []).filter(function (m) { return m && m.url; }).slice(0, 8);
      var media = fotos.map(function (m, i) { return '<button type="button" class="cg-review__foto" data-cg-lightbox="' + esc(m.url) + '" aria-label="Reviewfoto ' + (i + 1) + ' van ' + esc(x.n) + ' vergroten"><img src="' + esc(m.url) + '" alt="' + esc(m.alt || 'Reviewfoto') + '" loading="lazy" decoding="async"></button>'; }).join('');
      var mediaKlasse = fotos.length === 2 ? ' cg-review__media--twee' : (fotos.length > 2 ? ' cg-review__media--veel' : '');
      return '<article class="cg-review" data-cg-review data-rating="' + esc(x.r) + '" data-date="' + esc(x.d) + '">'
        + '<div class="cg-review__wie"><span class="cg-review__avatar" aria-hidden="true">' + esc(x.i) + '</span><div class="cg-review__naam"><span class="cg-review__auteur">' + esc(x.n) + '</span>' + (showVerified && x.v ? VERIFIED : '') + '</div></div>'
        + '<div class="cg-review__score">' + sterren(x.r, 16) + '</div>'
        + '<div class="cg-review__inhoud">' + (x.t ? '<h3 class="cg-review__titel">' + esc(x.t) + '</h3>' : '') + '<p class="cg-review__tekst">' + esc(x.b) + '</p>' + (media ? '<div class="cg-review__media' + mediaKlasse + '">' + media + '</div>' : '') + (x.d ? '<time class="cg-review__datum" datetime="' + esc(x.d) + '">' + esc(datum(x.d, loc)) + '</time>' : '') + '</div></article>';
    };
    var opDatum = function (a, b) { return String(b.d).localeCompare(String(a.d)); };
    var zichtbaar = function () {
      var l = st.filter === 'alle' ? st.alle.slice() : st.filter === 'foto' ? st.alle.filter(heeftFoto) : st.alle.filter(function (x) { return String(x.r) === String(st.filter); });
      l.sort(function (a, b) {
        if (st.sort === 'hoogste') return (b.r - a.r) || opDatum(a, b);
        if (st.sort === 'laagste') return (a.r - b.r) || opDatum(a, b);
        if (st.sort === 'foto') return (heeftFoto(b) - heeftFoto(a)) || opDatum(a, b);
        if (st.sort === 'behulpzaam') return (heeftFoto(b) - heeftFoto(a)) || (String(b.b).length - String(a.b).length) || opDatum(a, b);
        return opDatum(a, b);
      });
      return l;
    };
    var teken = function () {
      var l = zichtbaar();
      var deel = l.slice(0, st.getoond);
      lijst.innerHTML = deel.map(kaart).join('');
      if (leeg) leeg.hidden = deel.length > 0 || !st.klaar;
      var meerTeTonen = deel.length < l.length || (!st.klaar && (st.filter !== 'alle' || st.alle.length < count));
      if (meer) meer.hidden = !meerTeTonen;
    };
    /* Genoeg voor het huidige filter: laad pagina's door tot er 'getoond'
       passende reviews zijn of alles geladen is. Sorteren op score of foto
       vraagt de hele set: dan alles laden. */
    var vulAan = function () {
      var l = zichtbaar();
      if (l.length >= st.getoond || st.klaar) { teken(); return Promise.resolve(); }
      return laadPagina().then(function (ok) { if (ok) return vulAan(); teken(); });
    };
    var zetFilterKnoppen = function () {
      sec.querySelectorAll('[data-cg-filter]').forEach(function (x) { var aan = x.getAttribute('data-cg-filter') === st.filter; x.classList.toggle('is-actief', aan); x.setAttribute('aria-pressed', aan ? 'true' : 'false'); });
    };

    if (meer) meer.addEventListener('click', function () { if (st.laden) return; st.getoond += batch; vulAan(); });
    sec.querySelectorAll('[data-cg-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = b.getAttribute('data-cg-filter');
        /* Nog een keer op dezelfde ster klikken haalt het filter weg. */
        st.filter = (f === st.filter && f !== 'alle') ? 'alle' : f; st.getoond = batch;
        zetFilterKnoppen();
        var p = (st.filter === 'foto' && !st.klaar) ? laadAlles() : Promise.resolve();
        p.then(vulAan).then(function () { var eerste = lijst.querySelector('[data-cg-review]'); if (eerste && window.innerWidth < 750) eerste.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); });
      });
    });
    if (sortEl) sortEl.addEventListener('change', function () {
      st.sort = sortEl.value; st.getoond = batch;
      if (st.sort !== 'nieuwste' && !st.klaar) laadAlles().then(teken); else teken();
    });
    teken();
  });
})();
